import React from 'react'

function Art() {
  return (
    <div>Art</div>
  )
}

export default Art